// src/data/trizMatrix.js (データ構造強化・完成版)

/**
 * 矛盾マトリックスで使用する組織・人材開発向けのパラメータ。
 * ドロップダウンで利用しやすいように、オブジェクトの配列形式に変更。
 * 各パラメータにid, name, descriptionを保持させる。
 */
export const TRIZ_PARAMETERS = [
  { id: 1, name: "生産性・速度", description: "タスクの実行速度や処理能力" },
  { id: 2, name: "品質・信頼性", description: "成果物の正確さや安定性" },
  { id: 3, name: "コスト・資源", description: "必要となる費用や人的・物的リソース" },
  { id: 4, name: "時間・納期", description: "プロジェクトやタスクの所要時間" },
  { id: 5, name: "複雑さ・管理の容易さ", description: "システムの構造や運用のしやすさ" },
  { id: 6, name: "柔軟性・適応性", description: "変化に対応できる能力" },
  { id: 7, name: "創造性・新規性", description: "新しいアイデアを生み出す力" },
  { id: 8, name: "チームの士気・満足度", description: "メンバーのモチベーションや働きがい" },
  { id: 9, name: "情報共有・透明性", description: "組織内での情報の伝達しやすさ" }
];

/**
 * 矛盾マトリックス本体。
 * キーは「改善パラメータID-悪化パラメータID」の形式。
 * 値は推奨されるTRIZ原理IDの配列。
 * こちらは変更不要です。
 */
export const CONTRADICTION_MATRIX = {
  // 生産性(1)を上げたいが、品質(2)が下がる
  "1-2": [15, 28, 35, 1], // ダイナミック化, システム代替, パラメータ変更, 分割
  // 生産性(1)を上げたいが、コスト(3)が上がる
  "1-3": [1, 10, 27, 34], // 分割, 先取り作用, 安価な代替物, 廃棄と再生
  // 生産性(1)を上げたいが、士気(8)が下がる
  "1-8": [13, 30, 22, 35], // 逆発想, 柔軟な膜, 災い転じて福となす, パラメータ変更

  // 品質(2)を上げたいが、時間(4)がかかる
  "2-4": [10, 13, 19, 35], // 先取り作用, 逆発想, 周期的作用, パラメータ変更
  // 品質(2)を上げたいが、コスト(3)がかかる
  "2-3": [22, 24, 27, 40], // 災い転じて福となす, 仲介, 安価な代替物, 複合材料
  // 品質(2)を上げたいが、複雑さ(5)が増す
  "2-5": [1, 7, 26, 5], // 分割, 入れ子, コピー, 統合

  // 創造性(7)を高めたいが、生産性(1)が下がる
  "7-1": [13, 15, 18, 30], // 逆発想, ダイナミック化, 機械的振動, 柔軟な膜
  // 創造性(7)を高めたいが、品質(2)が不安定になる
  "7-2": [3, 11, 23, 32], // 局所的品質, 事前保護, フィードバック, 色を変える
  
  // 柔軟性(6)を高めたいが、複雑さ(5)が増す
  "6-5": [1, 5, 7, 30],   // 分割, 統合, 入れ子, 柔軟な膜
  // 柔軟性(6)を高めたいが、品質(2)・信頼性が下がる
  "6-2": [15, 29, 35, 30], // ダイナミック化, 流体・気体の利用, パラメータ変更, 柔軟な膜
};